var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-collapse-item",
    {
      ref: "collapseItem",
      staticClass: "my-3 collapse-item section bg-gray",
      attrs: {
        auto: "",
        "expanded-icon": "fas fa-chevron-circle-right color-gray-7",
        "minimized-icon": "fas fa-chevron-circle-down color-warning",
        "parent-id": "factors-collapse",
        "read-only-icon": "fas fa-plus-circle color-gray-2",
        "start-expanded": "",
        title: "GED"
      },
      on: {
        expandButtonClick: function($event) {
          return _vm.$emit("expandButtonClick")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "bg-white p-3 rounded" },
        [
          _c("div", { staticClass: "bg-light p-3 rounded mb-3 border" }, [
            _c(
              "div",
              { staticClass: "bg-white ged-legend-box" },
              [
                _c("div", { staticClass: "row font-weight-bold mb-2" }, [
                  _c("div", { staticClass: "col-3" }, [_vm._v("Nivel")]),
                  _c("div", { staticClass: "col-9" }, [_vm._v("Grado")])
                ]),
                _vm._l(_vm.levels, function(level) {
                  return _c(
                    "div",
                    {
                      key: `ged-level-${level.id}`,
                      staticClass: "row align-items-center mb-3"
                    },
                    [
                      _c("div", { staticClass: "col-3" }, [
                        _vm._v(_vm._s(level.name))
                      ]),
                      _c("div", { staticClass: "col-9" }, [
                        _vm.getGradeByLevel(level.id)
                          ? _c(
                              "span",
                              {
                                staticClass: "ged-chip",
                                style: _vm.getGradeStyle(
                                  _vm.getGradeByLevel(level.id)
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getGradeByLevel(level.id).name) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _vm._l(_vm.items, function(item) {
            return _c(
              "div",
              {
                key: `ged-item-${item.areaId}`,
                staticClass: "ged-item-card mb-3"
              },
              [
                _c("div", { staticClass: "ged-item-title" }, [
                  _vm._v(" " + _vm._s(item.name) + " ")
                ]),
                _c("div", { staticClass: "row align-items-end p-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", [_vm._v("Nivel Requerido de la Profesión:")]),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            attrs: {
                              name: `${item.name} - Nivel Requerido`,
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors: levelErrors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          clearable: "",
                                          disabled: _vm.isReadOnly,
                                          fieldkey: "id",
                                          fieldname: "name",
                                          options: _vm.levels,
                                          placeholder: "Seleccione",
                                          value: item.requiredLevel
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.updateItem(
                                              item,
                                              "requiredLevel",
                                              $event
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(levelErrors[0]) + " "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("empty")(item.requiredLevel.name)
                                ) +
                                " "
                            )
                          ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", [_vm._v("Perfil del Evaluado:")]),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            attrs: {
                              name: `${item.name} - Perfil Evaluado`,
                              rules: "required"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors: evaluatedErrors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          clearable: "",
                                          disabled: _vm.isReadOnly,
                                          fieldkey: "id",
                                          fieldname: "name",
                                          options: _vm.levels,
                                          placeholder: "Seleccione",
                                          value: item.evaluatedLevel
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.updateItem(
                                              item,
                                              "evaluatedLevel",
                                              $event
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(evaluatedErrors[0]) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("empty")(item.evaluatedLevel.name)
                                ) +
                                " "
                            )
                          ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-3 d-flex flex-column align-items-center"
                    },
                    [
                      _c("label", [_vm._v("Grado:")]),
                      _c("div", [
                        _vm.getGradeByLevel(item.evaluatedLevel)
                          ? _c(
                              "span",
                              {
                                staticClass: "ged-chip",
                                style: _vm.getGradeStyle(
                                  _vm.getGradeByLevel(item.evaluatedLevel)
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getGradeByLevel(item.evaluatedLevel)
                                        .name
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-lg-3 d-flex justify-content-lg-end ged-answer-wrapper mt-3 mt-lg-0"
                    },
                    [
                      _c("validation-provider", {
                        staticClass: "w-100",
                        attrs: {
                          name: `${item.name} - Respuesta`,
                          rules: "required"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors: answerErrors }) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.selectedAnswer,
                                        expression: "item.selectedAnswer"
                                      }
                                    ],
                                    attrs: { type: "hidden" },
                                    domProps: { value: item.selectedAnswer },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          item,
                                          "selectedAnswer",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap justify-content-lg-end"
                                    },
                                    _vm._l(_vm.answers, function(answer) {
                                      return _c(
                                        "button",
                                        {
                                          key: `ged-answer-${item.areaId}-${answer.id}`,
                                          staticClass: "ged-answer-btn",
                                          class: {
                                            active:
                                              item.selectedAnswer &&
                                              item.selectedAnswer.id ===
                                                answer.id
                                          },
                                          attrs: {
                                            disabled: _vm.isReadOnly,
                                            type: "button"
                                          },
                                          on: {
                                            click: function($event) {
                                              item.selectedAnswer = answer
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-check-circle d-block mb-1"
                                          }),
                                          _vm._v(
                                            " " + _vm._s(answer.name) + " "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _c(
                                    "small",
                                    { staticClass: "text-danger d-block mt-1" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(answerErrors[0]) + " "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          }),
          _c(
            "div",
            [
              _c("label", [_vm._v("Observaciones:")]),
              _c("custom-text-area", {
                attrs: {
                  "count-classes": ["d-block", "small-counter", "text-right"],
                  disabled: _vm.isReadOnly,
                  maxlength: 5000,
                  placeholder: "Comentario",
                  "show-char-count": ""
                },
                model: {
                  value: _vm.model.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "comment", $$v)
                  },
                  expression: "model.comment"
                }
              })
            ],
            1
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }